import Image from "next/image";
import { cn } from "@/lib/utils";
import type { CaseItem } from "@/components/ui/cases-block/types";

const CasesCard = (props: { item: CaseItem; className?: string }) => {
    const { title, description } = props.item;
    const { className = "" } = props;

    return (
        <div
            className={cn(
                "min-w-[228px] xl:min-w-[282px] min-h-[245px] flex-1 rounded-2xl overflow-hidden shadow-[0px_4px_3.9px_0px_#1045510F,0px_2px_26.2px_0px_#157FA217]",
                className,
            )}
        >
            <div className="relative h-25 w-full">
                <Image
                    src="/images/case-item-image.png"
                    alt="card deco"
                    fill
                    sizes="(max-width: 1200px) 100vw, 300px"
                    className="object-cover"
                />
            </div>

            <div className={"px-5 pb-5 pt-4 lg:pt-1 [font-family:var(--font-archivo)]"}>
                <h3 className={"font-semibold text-xl mb-2"}>{title}</h3>
                <p className={"text-[#39495C]"}>{description}</p>
            </div>
        </div>
    );
};

export default CasesCard;
